import { useCapabilities } from '@core/api/useCapabilities';
import { useOpenAlerts } from '../hooks/useComplianceAlerts';
import { tabBadgeCount } from '../lib/overview';

/**
 * The Compliance tab's count (display plan veto item 8): the open P1s plus the lower-severity alerts past their
 * deadline, from the same open-alerts query the P1 strip polls. Nothing at zero, when the console is off, or when the
 * backend cannot be reached (never an invented count).
 */
export function ComplianceTabBadge() {
  const caps = useCapabilities();
  const { data } = useOpenAlerts(caps.compliance !== false);
  return <TabBadgeView count={caps.compliance === false || !data ? 0 : tabBadgeCount(data)} />;
}

/** The badge's markup, split out so the tests render it with a count and no query client. */
export function TabBadgeView({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span
      className="ml-1 rounded-full px-1.5 text-[10px] font-bold leading-4 tabular-nums text-white"
      style={{ background: 'var(--loss)' }}
      title={`${count} ${count === 1 ? 'alert needs' : 'alerts need'} action: the open P1s and the overdue ones`}
      aria-label={`${count} alerts need action`}
    >
      {count}
    </span>
  );
}
